import { render, staticRenderFns } from "./Single-news.vue?vue&type=template&id=75eed252&"
import script from "./Single-news.vue?vue&type=script&lang=js&"
export * from "./Single-news.vue?vue&type=script&lang=js&"
import style0 from "./Single-news.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports